import React from "react";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import Qr from "./Qr"
import TerminalCodeInput from "./TerminalCodeInput"

class Step4 extends React.Component {
  state = {
    terminalCode: "",
  }

  getStepModeContent = (modeNum) => {
    switch (modeNum) {
      case 0:
        // Step 1: Instructions and either take a photo of QR code or begin typing ID of old terminal
        return 'Unknown step';
      case 1:
        // Step 2: Take a photo of QR code or type ID of old terminal
        return <Qr handleBack={this.props.handleBack} handleChangeTerminalCodeValue={this.handleChangeTerminalCodeValue} handleChangeMode={this.props.handleChangeMode} />
      case 2:
        // Step 3: Information of old terminal and either take a photo of QR code or begin typing ID of new terminal
        return <TerminalCodeInput handleTerminalValueChange={this.handleTerminalValueChange} handleGetTerminal={this.props.handleGetNewTerminal} terminalCodeInputValue={this.state.terminalCode} terminal={this.props.newTerminal}/>
      default:
        return 'Unknown step';
    }
  }


  handleTerminalValueChange = (event) => {
    this.setState({terminalCode: event.target.value});
  }
  
  handleChangeTerminalCodeValue = (newValue) => {
    this.setState({
      terminalCode: newValue});
  }

  
  render() {
    const { mainClasses, modeNum, newTerminal, handleNext, handleBack } = this.props;

    return (
        <React.Fragment>
          <Typography variant="title" component="h3" className={mainClasses.stepTitle}>Kirjaa uusi laite</Typography>
          <div>
            { this.getStepModeContent(modeNum) }
            <div className={mainClasses.buttonWrapper}>
              <Button className={mainClasses.stepButton} disabled={!(newTerminal && newTerminal.terminalData)} variant="contained" color="primary" onClick={() => handleNext(0)}>Jatka</Button>
            </div>
            <div className={mainClasses.buttonWrapper}>
              <Button className={mainClasses.stepButton} variant="outlined" onClick={handleBack}>Back</Button>
            </div>
          </div>
        </React.Fragment>
    );
  }
}

export default Step4;



// WEBPACK FOOTER //
// ./src/components/Steps/Step4.js